import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { useStyle } from "../style";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import moment from "moment";
import { useDispatch } from "react-redux";
import axios from "axios";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
const PurchaseInfo = ({setData,setPostData,forwardRef}) => {
  const classes = useStyle();
  const dispatch = useDispatch()
  const [billData, setBillData] = useState([])
  // const [docNo, setDocNo] = useState('')
  const[balance, setBalance] = useState('0.00')
  const [billNo, setBillNo] = useState(null)
  const [address , setAddress] = useState("")
  const [gstIn , setGstIn] = useState("")
  const [partyName , setPartyName] = useState("")
  const [date , setDate] = useState(moment().format())
  const outletId = localStorage.getItem("outlet_id");

  function handleBillChange(e, value) {
    console.log(value)
    setBillNo(value);
    if (value) {
      const selectedBill = billData.find((bill) => bill.docno === value.docno);
      // Update state based on the selected bill
      console.log(selectedBill)
      setAddress(selectedBill ? (selectedBill.add1 + " " + selectedBill.add2 + "," + selectedBill.city_name + "-" + selectedBill.pincode + "-" + selectedBill.state_name + "-" + selectedBill.country_name) : '');
      setGstIn(selectedBill ? selectedBill.gstin : '');
      setPartyName(selectedBill ? selectedBill.fullname : '');
      setBalance(selectedBill ? selectedBill.balance : '0.00')
      setDate(selectedBill ? selectedBill.docdate : moment().format());
    } else {
      // Clear values if no bill is selected
      setAddress('');
      setGstIn('');
      setPartyName('');
      setDate(moment().format());
    }
  }
  useEffect(()=>{
// axios.get('/v1/sales_return_master')
// .then(res=>setDocNo(res.data.Docno))
// .catch(err=> {
//   dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
// })
axios.get(`/v1/sales/verify/${outletId}`)
.then(res=>{
  setBillData(res.data)
  setData([])
})
.catch(err=>{
  console.log(err)
  dispatch(setSnackbar(true,'error',err.response.data.error))
})
  },[])
  function getOverallRange(data) {
    let overallRange = [];
  data.forEach(item => {
    let startCode = parseInt(item.barcode);
    let endCode = parseInt(item.barcode_to);
    let range = [];
    for (let i = startCode; i <= endCode; i++) {
      range.push(i.toString());
    }
    overallRange.push(range);
  });
  return overallRange;
  }

  function mergeData(data, data2) {
    // Initialize an empty array to store the merged data
    const mergedData = [];
  
    // Iterate through the arrays
    for (let i = 0; i < Math.min(data.length, data2.length); i++) {
      // Merge objects from both arrays
      const mergedObj = { ...data[i], barcodeData: data2[i.toString()], verifiedCode: [] };
      // Push the merged object into the result array
      mergedData.push(mergedObj);
    }
  
    return mergedData;
  }
  
  // const mergedData = mergeArrays(data, data2);
  // console.log(mergedData);
  
  useEffect(()=>{
if(billNo!==null){
  axios.get(`/v1/sales/${billNo.docno}`)
  .then(res=>{
    console.log(res.data)
    const kanchana = getOverallRange(res.data)
    console.log(kanchana)
    const arrData = res.data.map(item => ({
      ...item,
      retQty: 0,
      totalAmt: item.qty * item.rate,
      is_verify: false,
    }))
    setData( mergeData(arrData, kanchana))
    setPostData((prevState)=>({...prevState, mode : res.data[0].mode?.toLowerCase()}))
  })
  .catch(err=>{
    console.log(err)
    dispatch(setSnackbar(true,'error',err.response.data.error))
  })
}
  },[billNo])
  useEffect(() => {
    if(billNo){
      setPostData((prevState)=>({...prevState, partycode:billNo.partycode , company_id:billNo.company_id,sales_doc_no:billNo.docno}))
    }
  },[billNo])
  return (
    <Grid container spacing={2} className="p-2 h-full" >
         <Grid item lg={4} >
         <Autocomplete
        id="billNo"
        name="billNo"
        size="small"
        options={billData}
        getOptionLabel={option=> option.docno}
        onChange={(e,value)=>handleBillChange(e,value)}
        isOptionEqualToValue={(option, value)=> option.docno===value.docno}
        value={billNo}
        renderInput={(params)=>(
          <TextField {...params}
          label='Bill No'/>
        )}
        />
         <TextField size="small" label='Party Name' disabled fullWidth sx={{marginBlock: 2}} value={partyName}/>
          <TextField size="small" label='Address' disabled multiline rows={3.3} fullWidth value={address}/>
         </Grid>
        <Grid item lg={4}>
        {/* <TextField size="small" label='Doc No' fullWidth
        value={docNo}
        InputProps={{
          readOnly: true,
        }} /> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker value={dayjs(date)} label="Date" size="small" format="DD/MM/YYYY" slotProps={{
                  textField: {
                    size: "small",
                  },
                }}
                sx={{width: '100%',marginBlock:1.5}}
                />
        </LocalizationProvider>
        </Grid>
   <Grid item lg={4}>
        <Typography textAlign="center" variant="h6" sx={{backgroundColor:'#83A2FF',}}>Balance</Typography>
        <Typography textAlign='right' variant="h5" mt={1} sx={{fontWeight:600,}}>{balance}</Typography>
   </Grid>
    </Grid>
  );
};
export default memo(PurchaseInfo);